var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', {
    staticClass: "Footer"
  }, [_vm._v(" 版权所有 ©2012-" + _vm._s(_vm.year) + " 久其数字传播有限公司      "), _c('el-link', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "rel": "noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("京ICP备18018614号-6")]), _vm._v("      "), _c('el-link', {
    attrs: {
      "href": "https://pandarocket.cn/PANDAEDI",
      "rel": "noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("增值电信业务经营许可证：京B2-20203609 B2-20203609")]), _vm._v("      "), _c('el-link', {
    attrs: {
      "rel": "noreferrer",
      "target": "_blank",
      "href": "https://beian.mps.gov.cn/#/query/webSearch?code=11030102011668"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "16px",
      "vertical-align": "sub"
    },
    attrs: {
      "src": `${_vm.common.imageRoot}/copyrightimg.png`
    }
  }), _vm._v("京公网安备11030102011668号")])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };